// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Contravariant_Compat from "../Data.Functor.Contravariant.Compat/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Data_NamedParams from "../Data.NamedParams/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Record from "../Record/index.js";
import * as Restaumatic_Components_MultiSelect from "../Restaumatic.Components.MultiSelect/index.js";
import * as Restaumatic_Form_Checkbox from "../Restaumatic.Form.Checkbox/index.js";
import * as Restaumatic_Form_Delayed from "../Restaumatic.Form.Delayed/index.js";
import * as Restaumatic_Form_FormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_List from "../Restaumatic.Form.List/index.js";
import * as Restaumatic_Form_Mapping from "../Restaumatic.Form.Mapping/index.js";
import * as Restaumatic_Form_Optional from "../Restaumatic.Form.Optional/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic_Form_Translated from "../Restaumatic.Form.Translated/index.js";
import * as Restaumatic_Form_Widgets from "../Restaumatic.Form.Widgets/index.js";
import * as Restaumatic_I18n_Currency from "../Restaumatic.I18n.Currency/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_Components_IconList from "../Specular.Components.IconList/index.js";
import * as Specular_Components_Icons from "../Specular.Components.Icons/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Extra from "../Specular.Extra/index.js";
import * as Specular_Extra_Attr from "../Specular.Extra.Attr/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Extra from "../Specular.FRP.Extra/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_JQuery from "../Specular.JQuery/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder);
var applySecond = /* #__PURE__ */ Control_Apply.applySecond(Specular_Dom_Builder.applyBuilder);
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Specular_Dom_Builder.monadEffectBuilder);
var newRef = /* #__PURE__ */ Specular_Ref.newRef(Specular_Dom_Builder.monadEffectBuilder);
var monadFRP = /* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder);
var attachDyn = /* #__PURE__ */ Specular_Callback.attachDyn()(monadFRP);
var modify = /* #__PURE__ */ Specular_Ref.modify(Effect_Class.monadEffectEffect);
var unlessD = /* #__PURE__ */ Specular_FRP_Extra.unlessD(monadFRP)(Specular_Dom_Builder.monadReplaceBuilder);
var not = /* #__PURE__ */ Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
var whenD = /* #__PURE__ */ Specular_FRP_Extra.whenD(monadFRP)(Specular_Dom_Builder.monadReplaceBuilder);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder);
var readLabel = /* #__PURE__ */ Restaumatic_Form_Mapping.readLabel(Restaumatic_Form_Mapping.mappingLikeMapping);
var when = /* #__PURE__ */ Control_Applicative.when(Specular_Dom_Builder.applicativeBuilder);
var withUniqDynamic_ = /* #__PURE__ */ Specular_FRP_Extra.withUniqDynamic_(monadFRP)(Specular_Dom_Builder.monadReplaceBuilder);
var withUniqDynamic_1 = /* #__PURE__ */ withUniqDynamic_(/* #__PURE__ */ Data_Eq.eqArray(Data_Eq.eqString));
var for_ = /* #__PURE__ */ Data_Foldable.for_(Specular_Dom_Builder.applicativeBuilder)(Data_Foldable.foldableArray);
var mkNamedParamsFn = /* #__PURE__ */ Data_NamedParams.mkNamedParamsFn()();
var attr = /* #__PURE__ */ Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringProp);
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
    reflectSymbol: function () {
        return "label";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "key";
    }
});
var disabledIsSymbol = {
    reflectSymbol: function () {
        return "disabled";
    }
};
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var uniqDyn = /* #__PURE__ */ Specular_FRP_Base.uniqDyn(monadFRP);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder);
var initSelect2 = /* #__PURE__ */ Restaumatic_Components_MultiSelect.initSelect2();
var map1 = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var readDynamic1 = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var subscribeDyn_ = /* #__PURE__ */ Specular_FRP_Base.subscribeDyn_(monadFRP);
var applySecond1 = /* #__PURE__ */ Control_Apply.applySecond(Specular_FRP_Base.applyDynamic);
var onCleanup = /* #__PURE__ */ Control_Monad_Cleanup.onCleanup(Specular_Dom_Builder.monadCleanupBuilder);
var mwhen = /* #__PURE__ */ Data_Monoid_Extra.mwhen(Specular_Dom_Element.monoidProp);
var withDynamic_ = /* #__PURE__ */ Specular_FRP_Replaceable.withDynamic_(Specular_Dom_Builder.monadReplaceBuilder)(monadFRP);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var merge = /* #__PURE__ */ Record.merge()();
var isTextFieldTranslatedForm = /* #__PURE__ */ Restaumatic_Form_Translated.isTextFieldTranslatedForm(Restaumatic_Form_FormField["isRefLikeFormField$prime"])(Restaumatic_Form_FormField["hasContextFormField$prime"])(Restaumatic_Form_FormField["formFieldLikeFormField$prime"]);
var getLabel = /* #__PURE__ */ Restaumatic_Form_Internal.getLabel(Restaumatic_Form_FormField["hasLabelFormField$prime"]);
var deleteItem = /* #__PURE__ */ Restaumatic_Form_List.deleteItem(Restaumatic_Form_List.itemLikeItem);
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_Foldable.foldableArray)(Specular_Dom_Element.monoidProp);
var exists = /* #__PURE__ */ Restaumatic_Form_Optional.exists(Restaumatic_Form_Optional.optionalFieldLikeOptional)(Restaumatic_Form_Delayed.unwrapFunctorIdentity);
var queryLaxWithDefault = /* #__PURE__ */ Restaumatic_Form_Query.queryLaxWithDefault(/* #__PURE__ */ Restaumatic_Form_FormField["queryFormField$prime"](Type_Equality.refl));
var subform = /* #__PURE__ */ Restaumatic_Form_Optional.subform(Restaumatic_Form_Optional.optionalFieldLikeOptional)(Restaumatic_Form_Delayed.unwrapFunctorIdentity);
var $$void = /* #__PURE__ */ Data_Functor["void"](Effect.functorEffect);
var UseDefault = /* #__PURE__ */ (function () {
    function UseDefault() {

    };
    UseDefault.value = new UseDefault();
    return UseDefault;
})();
var LabelDefault = /* #__PURE__ */ (function () {
    function LabelDefault() {

    };
    LabelDefault.value = new LabelDefault();
    return LabelDefault;
})();
var LabelBooleanControl = /* #__PURE__ */ (function () {
    function LabelBooleanControl() {

    };
    LabelBooleanControl.value = new LabelBooleanControl();
    return LabelBooleanControl;
})();
var DefaultEmptyLabel = /* #__PURE__ */ (function () {
    function DefaultEmptyLabel() {

    };
    DefaultEmptyLabel.value = new DefaultEmptyLabel();
    return DefaultEmptyLabel;
})();
var toGroupNameUseDefault = {
    toGroupName: function (v) {
        return v.fieldId;
    }
};
var toGroupNameString = {
    toGroupName: function (v) {
        return v.value;
    }
};
var fieldLabelDefaultEmptyLab = {
    renderLabelWithMode: function (v) {
        return function (v1) {
            return Restaumatic_Prelude_Specular.wempty;
        };
    },
    isVisible: function (v) {
        return function (v1) {
            return false;
        };
    },
    isDefault: function (v) {
        return true;
    }
};
var wrapItem = /* #__PURE__ */ Specular_Dom_Element.el("div")([ /* #__PURE__ */ Specular_Dom_Element.attr("style")("margin: 5px; margin-left: 10px; padding: 5px; border: 1px solid black;") ]);
var translatedFieldWrapper = function (body) {
    return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("input-group") ])(discard(Specular_Dom_Element.el("span")([ Specular_Dom_Element.attr("title")("Pole t\u0142umaczone"), Specular_Dom_Element.class_("input-group-addon") ])(Specular_Dom_Element.el("span")([ Specular_Dom_Element.attr("aria-hidden")("true"), Specular_Dom_Element.class_("icon-flag") ])(Restaumatic_Prelude_Specular.wempty)))(function () {
        return body;
    }));
};
var toGroupName = function (dict) {
    return dict.toGroupName;
};
var sortIcon = /* #__PURE__ */ discard(/* #__PURE__ */ Specular_Dom_Element.el("i")([ /* #__PURE__ */ Specular_Dom_Element.class_("icon-sort") ])(Restaumatic_Prelude_Specular.wempty))(function () {
    return Specular_Extra.nbsp;
});
var renderLabelWithMode = function (dict) {
    return dict.renderLabelWithMode;
};
var renderLabel = function (dictFieldLabel) {
    return renderLabelWithMode(dictFieldLabel)(LabelDefault.value);
};
var plusIcon = /* #__PURE__ */ applySecond(/* #__PURE__ */ Specular_Dom_Element.el("span")([ /* #__PURE__ */ Specular_Dom_Element.attr("aria-hidden")("true"), /* #__PURE__ */ Specular_Dom_Element.class_("icon-plus-sign") ])(Restaumatic_Prelude_Specular.wempty))(Specular_Extra.nbsp);
var panelToggle = function (label1) {
    return function (forceExpand) {
        return function (body) {
            return bind(bind(readDynamic(forceExpand))(newRef))(function (expanded) {
                return discard(attachDyn(forceExpand)(Data_Functor_Contravariant_Compat.cmap(function (a) {
                    return function (b) {
                        return a || b;
                    };
                })(modify(expanded))))(function () {
                    return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel"), Specular_Dom_Element.class_("panel-default") ])(discard(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel-heading"), Specular_Dom_Element.class_("sortable-handle") ])(discard(unlessD(forceExpand)(Specular_Dom_Element.el("button")([ Specular_Dom_Element.onClick_(modify(expanded)(not)), Specular_Dom_Element.attr("type")("button"), Specular_Dom_Element.class_("btn"), Specular_Dom_Element.class_("btn-default"), Specular_Dom_Element.class_("btn-sm"), Specular_Dom_Element.class_("pull-right") ])(discard(Specular_Dom_Element.el("span")([ Specular_Dom_Element.attr("aria-hidden")("true"), Specular_Dom_Element.classWhenD(Specular_Ref.value(expanded))("icon-caret-up"), Specular_Dom_Element.classUnlessD(Specular_Ref.value(expanded))("icon-caret-down") ])(Restaumatic_Prelude_Specular.wempty))(function () {
                        return discard(Specular_Extra.nbsp)(function () {
                            return discard(whenD(Specular_Ref.value(expanded))(Specular_Dom_Element.text("Zwi\u0144")))(function () {
                                return unlessD(Specular_Ref.value(expanded))(Specular_Dom_Element.text("Rozwi\u0144"));
                            });
                        });
                    }))))(function () {
                        return label1;
                    })))(function () {
                        return whenD(Specular_Ref.value(expanded))(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel-body") ])(body));
                    }));
                });
            });
        };
    };
};
var panel$prime = function (label1) {
    return function (body) {
        return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel"), Specular_Dom_Element.class_("panel-default") ])(discard(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel-heading"), Specular_Dom_Element.class_("sortable-handle") ])(label1))(function () {
            return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel-body") ])(body);
        }));
    };
};
var panel = function (classes$prime) {
    return function (body) {
        return Specular_Dom_Element.el("div")([ Specular_Dom_Element.classes(append([ "panel", "panel-default" ])(classes$prime)) ])(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("panel-body") ])(body));
    };
};
var panel_ = function (body) {
    return panel(mempty)(body);
};
var labelWidget = function (dictTypeEquals) {
    var from = Type_Equality.from(dictTypeEquals);
    return {
        renderLabelWithMode: function (v) {
            return Specular_Dom_Builder.local(from);
        },
        isVisible: function (v) {
            return function (v1) {
                return true;
            };
        },
        isDefault: function (v) {
            return false;
        }
    };
};
var labelUnit = {
    renderLabelWithMode: function (v) {
        return function (v1) {
            return Restaumatic_Prelude_Specular.wempty;
        };
    },
    isVisible: function (v) {
        return function (v1) {
            return false;
        };
    },
    isDefault: function (v) {
        return false;
    }
};
var label = /* #__PURE__ */ Specular_Dom_Element.el("label")([ /* #__PURE__ */ Specular_Dom_Element.class_("control-label") ]);
var labelString = {
    renderLabelWithMode: function (v) {
        return function (v1) {
            if (v1 === "") {
                return Restaumatic_Prelude_Specular.wempty;
            };
            if (v instanceof LabelDefault) {
                return label(Specular_Dom_Element.text(v1));
            };
            if (v instanceof LabelBooleanControl) {
                return Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("control-label") ])(Specular_Dom_Element.text(v1));
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Widgets.Bootstrap (line 53, column 1 - line 63, column 22): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    isVisible: function (v) {
        return function (v1) {
            if (v instanceof LabelDefault && v1 === "") {
                return false;
            };
            return true;
        };
    },
    isDefault: function (v) {
        return false;
    }
};
var renderLabel1 = /* #__PURE__ */ renderLabel(labelString);
var renderLabelWithMode1 = /* #__PURE__ */ renderLabelWithMode(labelString);
var isVisible = function (dict) {
    return dict.isVisible;
};
var isVisible1 = /* #__PURE__ */ isVisible(labelString);
var isDefault = function (dict) {
    return dict.isDefault;
};
var isVisibleFieldLabel = function (dictFieldLabel) {
    var isDefault1 = isDefault(dictFieldLabel);
    var isVisible2 = isVisible(dictFieldLabel);
    return function (l) {
        return function (fieldLabelD) {
            return bind(readDynamic(fieldLabelD))(function (fieldLabel) {
                return pure((function () {
                    if (fieldLabel instanceof Data_Maybe.Just && isDefault1(l)) {
                        return isVisible1(LabelDefault.value)(fieldLabel.value0);
                    };
                    return isVisible2(LabelDefault.value)(l);
                })());
            });
        };
    };
};
var renderFieldLabel = function (dictFieldLabel) {
    var isDefault1 = isDefault(dictFieldLabel);
    var renderLabel2 = renderLabel(dictFieldLabel);
    return function (l) {
        return function (fieldLabelD) {
            return bind(readDynamic(fieldLabelD))(function (fieldLabel) {
                if (fieldLabel instanceof Data_Maybe.Just && isDefault1(l)) {
                    return renderLabel1(fieldLabel.value0);
                };
                return renderLabel2(l);
            });
        };
    };
};
var mappingField = function (dictOrd) {
    var display = Restaumatic_Form_Mapping.display(dictOrd)(monadFRP)(Specular_Dom_Builder.monadReplaceBuilder)(Restaumatic_Form_Mapping.mappingLikeMapping);
    return function (dictFieldLabel) {
        var renderFieldLabel1 = renderFieldLabel(dictFieldLabel);
        return function (label1) {
            return function (f) {
                return function (renderItem) {
                    return Specular_Dom_Element.el("div")([ Specular_Dom_Element.classes([ "form-group" ]) ])(discard(renderFieldLabel1(label1)(readLabel(f)))(function () {
                        return display(f)(renderItem);
                    }));
                };
            };
        };
    };
};
var infoText = /* #__PURE__ */ Specular_Dom_Element.el("p")([ /* #__PURE__ */ Specular_Dom_Element.class_("m-form__info-text") ]);
var formGroup = function (label1) {
    return function (body) {
        return Specular_Dom_Element.el("div")([ Specular_Dom_Element.classes([ "form-group" ]) ])(discard(when(label1 !== "")(Specular_Dom_Element.el("label")([ Specular_Dom_Element.class_("control-label") ])(Specular_Dom_Element.text(label1))))(function () {
            return body;
        }));
    };
};
var fieldset$prime = function (label1) {
    return function (body) {
        return Specular_Dom_Element.el("fieldset")([ Specular_Dom_Element.class_("form-fieldset") ])(discard(Specular_Dom_Element.el_("legend")(label1))(function () {
            return body;
        }));
    };
};
var fieldset = function (label1) {
    return fieldset$prime(Specular_Dom_Element.text(label1));
};
var errorMessage = function (error) {
    return Specular_Dom_Element.el("p")([ Specular_Dom_Element.class_("invalid-feedback") ])(discard(Specular_Components_Icons.icon([ Specular_Components_IconList.md18 ])(Specular_Components_IconList.error))(function () {
        return discard(Specular_Extra.nbsp)(function () {
            return Specular_Dom_Element.text(error);
        });
    }));
};
var displayErrorMessage = function (dictHasErrors) {
    var displayedErrors = Restaumatic_Form_Internal.displayedErrors(dictHasErrors);
    return function (f) {
        return withUniqDynamic_1(displayedErrors(f))(function (errors) {
            return for_(errors)(errorMessage);
        });
    };
};
var radioGroup = function () {
    return function (dictHasErrors) {
        var hasDisplayedErrors = Restaumatic_Form_Internal.hasDisplayedErrors(dictHasErrors);
        var displayErrorMessage1 = displayErrorMessage(dictHasErrors);
        return function (dictIsSelectField) {
            var selectGetOptions = Restaumatic_Form_Internal.selectGetOptions(dictIsSelectField);
            return function (dictToOptionId) {
                var toOptionId = Specular_Select.toOptionId(dictToOptionId);
                return function (dictHasFieldId) {
                    var fieldId = Restaumatic_Form_Widgets.fieldId(dictHasFieldId);
                    var getFieldId = Restaumatic_Form_Internal.getFieldId(dictHasFieldId);
                    return function (dictFieldLabel) {
                        return function (dictToGroupName) {
                            var toGroupName1 = toGroupName(dictToGroupName);
                            return function (dictShow) {
                                var radio = Restaumatic_Form_Widgets.radio(dictShow);
                                return function (dictEq) {
                                    var withUniqDynamic_2 = withUniqDynamic_(Data_Eq.eqArray(eqRec(Data_Eq.eqRowCons(eqRowCons(dictEq))()(disabledIsSymbol)(Data_Eq.eqBoolean))));
                                    var radio1 = radio(dictEq)(dictIsSelectField);
                                    return function () {
                                        return function () {
                                            return mkNamedParamsFn({
                                                label: DefaultEmptyLabel.value,
                                                props: [  ],
                                                groupName: UseDefault.value
                                            })(function (params) {
                                                return Specular_Dom_Element.el("div")([ Specular_Dom_Element.classes([ "form-group", "form-field" ]), fieldId(params.field), attr("data-field-type")("radioGroup"), Specular_Dom_Element.classWhenD(hasDisplayedErrors(params.field))("has-error") ])(discard(withUniqDynamic_2(map(Specular_Select.flattenOptions)(selectGetOptions(params.field)))(function (opts) {
                                                    return for_(opts)(function (option) {
                                                        return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("radio"), attr("data-option-id")(toOptionId(option.key)) ])(Specular_Dom_Element.el_("label")(discard(radio1(toGroupName1({
                                                            fieldId: getFieldId(params.field),
                                                            value: params.groupName
                                                        }))(option)(params.props)(params.field))(function () {
                                                            return renderLabelWithMode1(LabelBooleanControl.value)(option.label);
                                                        })));
                                                    });
                                                }))(function () {
                                                    return displayErrorMessage1(params.field);
                                                }));
                                            });
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var selectField = function () {
    return function (dictIsSelectField) {
        return function (dictHasErrors) {
            var hasDisplayedErrors = Restaumatic_Form_Internal.hasDisplayedErrors(dictHasErrors);
            var displayErrorMessage1 = displayErrorMessage(dictHasErrors);
            return function (dictHasFieldId) {
                var fieldId = Restaumatic_Form_Widgets.fieldId(dictHasFieldId);
                return function (dictHasLabel) {
                    var getLabel1 = Restaumatic_Form_Internal.getLabel(dictHasLabel);
                    return function (dictFieldLabel) {
                        var isDefault1 = isDefault(dictFieldLabel);
                        var renderLabel2 = renderLabel(dictFieldLabel);
                        return function (dictShow) {
                            var select = Restaumatic_Form_Widgets.select(dictShow);
                            return function (dictEq) {
                                var selectInput = Restaumatic_Form_Internal.selectInput(dictEq)(dictIsSelectField);
                                var uniqDyn1 = uniqDyn(Data_Eq.eqArray(Specular_Select.eqOption(Data_Maybe.eqMaybe(dictEq))));
                                var select1 = select(dictEq);
                                return function (dictToOptionId) {
                                    var toOptionIdMaybe = Specular_Select.toOptionIdMaybe(dictToOptionId);
                                    var fromSelectOptions = Restaumatic_Components_MultiSelect.fromSelectOptions(toOptionIdMaybe);
                                    var toOptionId = Specular_Select.toOptionId(Specular_Select.toOptionIdMaybe(toOptionIdMaybe));
                                    var toOptionId1 = Specular_Select.toOptionId(toOptionIdMaybe);
                                    var select2 = select1(dictToOptionId)(dictIsSelectField);
                                    return function () {
                                        return function () {
                                            var select21 = function (params) {
                                                var selectInput1 = selectInput(params.field);
                                                return bind(uniqDyn1(selectInput1.displayedOptions))(function (optionsD) {
                                                    var entriesD = map(fromSelectOptions)(optionsD);
                                                    return bind(Specular_Dom_Element["el$prime"]("input")(params.props)(Restaumatic_Prelude_Specular.wempty))(function (v) {
                                                        var jq = Specular_JQuery.fromNode(v.value0);
                                                        return discard(liftEffect(initSelect2(jq)({
                                                            data: map1(function (v1) {
                                                                return {
                                                                    results: v1
                                                                };
                                                            })(readDynamic1(entriesD)),
                                                            containerCssClass: "form-control",
                                                            multiple: false,
                                                            placeholder: ""
                                                        })({
                                                            addCustomField: true
                                                        })))(function () {
                                                            return discard(Data_Function.flip(subscribeDyn_)(applySecond1(optionsD)(selectInput1.displayedValue))(function (value) {
                                                                return Restaumatic_Components_MultiSelect.setValue(jq)(toOptionId(value));
                                                            }))(function () {
                                                                var onChange = function (v1) {
                                                                    return function __do() {
                                                                        var value = Restaumatic_Components_MultiSelect.getValue(jq)();
                                                                        var opts = readDynamic1(selectInput1.displayedOptions)();
                                                                        var opt = Specular_Select.findOption(function (o) {
                                                                            return toOptionId1(o.key) === value;
                                                                        })(opts);
                                                                        return selectInput1.onChange(Data_Maybe.maybe(Data_Maybe.Nothing.value)(function (v2) {
                                                                            return v2.key;
                                                                        })(opt))();
                                                                    };
                                                                };
                                                                return bind(liftEffect(Specular_JQuery.addEventListener("change")(onChange)(jq)))(function (unsub) {
                                                                    return onCleanup(unsub);
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            };
                                            return mkNamedParamsFn({
                                                label: DefaultEmptyLabel.value,
                                                props: [  ],
                                                select2: false
                                            })(function (params) {
                                                return Specular_Dom_Element.el("div")([ fieldId(params.field), Specular_Dom_Element.class_("form-field"), Specular_Dom_Element.classWhenD(hasDisplayedErrors(params.field))("has-error"), mwhen(params.select2)(attr("data-custom-field-type")("select2")) ])(discard(withDynamic_(map(Data_Maybe.fromMaybe(""))(getLabel1(params.field)))(function (fieldLabel) {
                                                    var $337 = isDefault1(params.label);
                                                    if ($337) {
                                                        return renderLabel1(fieldLabel);
                                                    };
                                                    return renderLabel2(params.label);
                                                }))(function () {
                                                    return discard((function () {
                                                        if (params.select2) {
                                                            return select21(params);
                                                        };
                                                        return select2(append([ Specular_Dom_Element.class_("form-control") ])(params.props))(params.field);
                                                    })())(function () {
                                                        return displayErrorMessage1(params.field);
                                                    });
                                                }));
                                            });
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var textField$prime = function (dictHasErrors) {
    var hasDisplayedErrors = Restaumatic_Form_Internal.hasDisplayedErrors(dictHasErrors);
    var displayErrorMessage1 = displayErrorMessage(dictHasErrors);
    return function (dictHasFieldId) {
        var fieldId = Restaumatic_Form_Widgets.fieldId(dictHasFieldId);
        return function (dictFieldLabel) {
            var isVisibleFieldLabel1 = isVisibleFieldLabel(dictFieldLabel);
            var renderFieldLabel1 = renderFieldLabel(dictFieldLabel);
            return function (widget) {
                return function (params) {
                    return bind(isVisibleFieldLabel1(params.label)(params.fieldLabel))(function (labelVisible) {
                        return Specular_Dom_Element.el("div")([ fieldId(params.field), Specular_Dom_Element.classes([ "form-group", "form-field" ]), Specular_Dom_Element.classWhenD(hasDisplayedErrors(params.field))("has-error"), Specular_Dom_Element.classUnless(labelVisible)("form-field--inline") ])(discard(when(labelVisible)(renderFieldLabel1(params.label)(params.fieldLabel)))(function () {
                            return discard(params.wrapper(widget(append([ Specular_Dom_Element.class_("form-control") ])(params.props))(params.field)))(function () {
                                if (params.displayErrors) {
                                    return displayErrorMessage1(params.field);
                                };
                                return Restaumatic_Prelude_Specular.wempty;
                            });
                        }));
                    });
                };
            };
        };
    };
};
var textField$prime1 = /* #__PURE__ */ textField$prime(/* #__PURE__ */ Restaumatic_Form_Translated.hasErrorsTranslatedFormFi(Restaumatic_Form_FormField["hasErrorsFormField$prime"]))(/* #__PURE__ */ Restaumatic_Form_Translated.hasFieldIdTranslatedFormF(Restaumatic_Form_FormField["hasFieldIdFormField$prime"]));
var textAreaField = function (dictHasErrors) {
    var textField$prime2 = textField$prime(dictHasErrors);
    return function (dictFieldLabel) {
        return function (dictIsTextField) {
            var textArea = Restaumatic_Form_Widgets.textArea(dictIsTextField);
            return function (dictHasLabel) {
                var getLabel1 = Restaumatic_Form_Internal.getLabel(dictHasLabel);
                return function (dictHasFieldId) {
                    var textField$prime3 = textField$prime2(dictHasFieldId)(dictFieldLabel);
                    return function () {
                        return function () {
                            return mkNamedParamsFn({
                                label: DefaultEmptyLabel.value,
                                props: [  ],
                                displayErrors: true,
                                wrapper: identity
                            })(function (params) {
                                return textField$prime3(textArea)(merge({
                                    fieldLabel: getLabel1(params.field)
                                })(params));
                            });
                        };
                    };
                };
            };
        };
    };
};
var textField = function (dictHasErrors) {
    var textField$prime2 = textField$prime(dictHasErrors);
    return function (dictFieldLabel) {
        return function (dictIsTextField) {
            var textInput = Restaumatic_Form_Widgets.textInput(dictIsTextField);
            return function (dictHasLabel) {
                var getLabel1 = Restaumatic_Form_Internal.getLabel(dictHasLabel);
                return function (dictHasFieldId) {
                    var textField$prime3 = textField$prime2(dictHasFieldId)(dictFieldLabel);
                    return function () {
                        return function () {
                            return mkNamedParamsFn({
                                label: DefaultEmptyLabel.value,
                                props: [  ],
                                displayErrors: true,
                                wrapper: identity
                            })(function (params) {
                                return textField$prime3(textInput)(merge({
                                    fieldLabel: getLabel1(params.field)
                                })(params));
                            });
                        };
                    };
                };
            };
        };
    };
};
var priceField = function (dictHasErrors) {
    var textField1 = textField(dictHasErrors);
    return function (dictIsTextField) {
        return function (dictHasFieldId) {
            return function (dictHasLabel) {
                return function (dictFieldLabel) {
                    var textField2 = textField1(dictFieldLabel)(dictIsTextField)(dictHasLabel)(dictHasFieldId)()();
                    return function () {
                        return function () {
                            return mkNamedParamsFn({
                                label: "",
                                props: [  ]
                            })(function (params) {
                                var wrapper = function (body) {
                                    return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("input-group") ])(discard(body)(function () {
                                        return Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("input-group-addon") ])(Specular_Dom_Element.text(Restaumatic_I18n_Currency.currencyUnit(params.currency)));
                                    }));
                                };
                                return textField2({
                                    field: params.field,
                                    label: params.label,
                                    props: params.props,
                                    displayErrors: false,
                                    wrapper: wrapper
                                });
                            });
                        };
                    };
                };
            };
        };
    };
};
var translatedTextAreaField = function (dictIsRefLike) {
    var isTextFieldTranslatedForm1 = Restaumatic_Form_Translated.isTextFieldTranslatedForm(dictIsRefLike);
    return function (dictHasContext) {
        var isTextFieldTranslatedForm2 = isTextFieldTranslatedForm1(dictHasContext);
        return function (dictAsTranslatedString) {
            return function (dictFormFieldLike) {
                var textArea = Restaumatic_Form_Widgets.textArea(isTextFieldTranslatedForm2(dictFormFieldLike)(dictAsTranslatedString));
                var readLabel1 = Restaumatic_Form_FormField.readLabel(dictFormFieldLike);
                return function (dictFieldLabel) {
                    return function (dictIsTextField) {
                        return function (dictHasFieldId) {
                            var hasFieldIdTranslatedFormF = Restaumatic_Form_Translated.hasFieldIdTranslatedFormF(dictHasFieldId);
                            return function (dictHasErrors) {
                                var textField$prime2 = textField$prime(Restaumatic_Form_Translated.hasErrorsTranslatedFormFi(dictHasErrors))(hasFieldIdTranslatedFormF)(dictFieldLabel);
                                return function () {
                                    return function () {
                                        return mkNamedParamsFn({
                                            label: DefaultEmptyLabel.value,
                                            props: [  ],
                                            displayErrors: true,
                                            wrapper: translatedFieldWrapper
                                        })(function (params) {
                                            return textField$prime2(textArea)(merge({
                                                field: params.field,
                                                fieldLabel: readLabel1(params.field)
                                            })(params));
                                        });
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var translatedTextField = function (dictAsTranslatedString) {
    var textInput = Restaumatic_Form_Widgets.textInput(isTextFieldTranslatedForm(dictAsTranslatedString));
    return function (dictFieldLabel) {
        var textField$prime2 = textField$prime1(dictFieldLabel);
        return function () {
            return function () {
                return mkNamedParamsFn({
                    label: DefaultEmptyLabel.value,
                    props: [  ],
                    displayErrors: true,
                    wrapper: translatedFieldWrapper
                })(function (params) {
                    return textField$prime2(textInput)(merge({
                        field: params.field,
                        fieldLabel: getLabel(params.field)
                    })(params));
                });
            };
        };
    };
};
var displayErrorHint = function (dictHasErrors) {
    var displayedErrors = Restaumatic_Form_Internal.displayedErrors(dictHasErrors);
    return function (f) {
        return withUniqDynamic_1(displayedErrors(f))(function (errors) {
            return for_(errors)(function (error) {
                return Specular_Dom_Element.el("p")([ Specular_Dom_Element.class_("help-block") ])(Specular_Dom_Element.text(error));
            });
        });
    };
};
var deleteButton = function (dictEq) {
    return function (item) {
        return Specular_Dom_Element.el("button")([ Specular_Dom_Element.classes([ "btn", "btn-default", "btn-sm" ]), Specular_Dom_Element.attr("type")("button"), Specular_Dom_Element.onClick_(deleteItem(item)) ])(discard(applySecond(Specular_Dom_Element.el("span")([ Specular_Dom_Element.attr("aria-hidden")("true"), Specular_Dom_Element.class_("icon-trash") ])(Restaumatic_Prelude_Specular.wempty))(Specular_Extra.nbsp))(function () {
            return Specular_Dom_Element.text("Usu\u0144");
        }));
    };
};
var dateTimeLocalField = function (dictIsRefLike) {
    var dateTimePickerLocal = Restaumatic_Form_Widgets.dateTimePickerLocal(dictIsRefLike);
    return function (dictHasErrors) {
        var textField$prime2 = textField$prime(dictHasErrors);
        return function (dictAsDateTime) {
            var dateTimePickerLocal1 = dateTimePickerLocal(dictAsDateTime)()();
            return function (dictFieldLabel) {
                return function (dictHasLabel) {
                    var getLabel1 = Restaumatic_Form_Internal.getLabel(dictHasLabel);
                    return function (dictHasFieldId) {
                        var textField$prime3 = textField$prime2(dictHasFieldId)(dictFieldLabel);
                        return function () {
                            return function () {
                                return mkNamedParamsFn({
                                    label: DefaultEmptyLabel.value,
                                    placeholder: "",
                                    props: [  ],
                                    displayErrors: true,
                                    min: Data_Maybe.Nothing.value
                                })(function (params) {
                                    return textField$prime3(function (props) {
                                        return function (field) {
                                            return dateTimePickerLocal1({
                                                props: props,
                                                field: field,
                                                min: params.min
                                            });
                                        };
                                    })({
                                        field: params.field,
                                        label: params.label,
                                        fieldLabel: getLabel1(params.field),
                                        props: [ attr("placeholder")(params.placeholder), fold(params.props) ],
                                        displayErrors: params.displayErrors,
                                        wrapper: identity
                                    });
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};
var dateField = function (dictIsRefLike) {
    var datePicker = Restaumatic_Form_Widgets.datePicker(dictIsRefLike);
    return function (dictHasErrors) {
        var textField$prime2 = textField$prime(dictHasErrors);
        return function (dictAsDate) {
            var datePicker1 = datePicker(dictAsDate);
            return function (dictFieldLabel) {
                return function (dictHasLabel) {
                    var getLabel1 = Restaumatic_Form_Internal.getLabel(dictHasLabel);
                    return function (dictHasFieldId) {
                        var textField$prime3 = textField$prime2(dictHasFieldId)(dictFieldLabel);
                        return function () {
                            return function () {
                                return mkNamedParamsFn({
                                    label: DefaultEmptyLabel.value,
                                    placeholder: "",
                                    props: [  ],
                                    displayErrors: true
                                })(function (params) {
                                    return textField$prime3(datePicker1)({
                                        field: params.field,
                                        label: params.label,
                                        fieldLabel: getLabel1(params.field),
                                        props: [ attr("placeholder")(params.placeholder), fold(params.props) ],
                                        displayErrors: params.displayErrors,
                                        wrapper: identity
                                    });
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};
var checkbox = function (dictFieldLabel) {
    var isDefault1 = isDefault(dictFieldLabel);
    var renderLabelWithMode2 = renderLabelWithMode(dictFieldLabel);
    return function (dictIsCheckboxField) {
        var checkbox1 = Restaumatic_Form_Widgets.checkbox(dictIsCheckboxField);
        return function (dictHasFieldId) {
            var fieldId = Restaumatic_Form_Widgets.fieldId(dictHasFieldId);
            return function (dictHasLabel) {
                var getLabel1 = Restaumatic_Form_Internal.getLabel(dictHasLabel);
                return function () {
                    return function () {
                        return mkNamedParamsFn({
                            label: DefaultEmptyLabel.value,
                            props: [  ],
                            withFieldId: true
                        })(function (params) {
                            return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("checkbox"), mwhen(params.withFieldId)(fieldId(params.field)) ])(Specular_Dom_Element.el_("label")(discard(checkbox1(params.props)(params.field))(function () {
                                return discard(Specular_Dom_Element.text(" "))(function () {
                                    return withDynamic_(map(Data_Maybe.fromMaybe(""))(getLabel1(params.field)))(function (fieldLabel) {
                                        var $340 = isDefault1(params.label);
                                        if ($340) {
                                            return renderLabelWithMode1(LabelBooleanControl.value)(fieldLabel);
                                        };
                                        return renderLabelWithMode2(LabelBooleanControl.value)(params.label);
                                    });
                                });
                            })));
                        });
                    };
                };
            };
        };
    };
};
var checkboxField = function (dictFieldLabel) {
    var checkbox1 = checkbox(dictFieldLabel);
    return function (dictFieldLabel1) {
        var isVisible2 = isVisible(dictFieldLabel1);
        var renderLabelWithMode2 = renderLabelWithMode(dictFieldLabel1);
        return function (dictIsCheckboxField) {
            var checkbox2 = checkbox1(dictIsCheckboxField);
            return function (dictHasErrors) {
                var hasDisplayedErrors = Restaumatic_Form_Internal.hasDisplayedErrors(dictHasErrors);
                var displayErrorMessage1 = displayErrorMessage(dictHasErrors);
                return function (dictHasLabel) {
                    return function (dictHasFieldId) {
                        var fieldId = Restaumatic_Form_Widgets.fieldId(dictHasFieldId);
                        var checkbox3 = checkbox2(dictHasFieldId)(dictHasLabel)()();
                        return function () {
                            return function () {
                                return mkNamedParamsFn({
                                    label: DefaultEmptyLabel.value,
                                    title: "",
                                    props: [  ]
                                })(function (params) {
                                    return discard(Specular_Dom_Element.el("div")([ fieldId(params.field), Specular_Dom_Element.classes([ "form-group", "form-field" ]), Specular_Dom_Element.classWhenD(hasDisplayedErrors(params.field))("has-error") ])(discard(when(isVisible2(LabelDefault.value)(params.title))(renderLabelWithMode2(LabelBooleanControl.value)(params.title)))(function () {
                                        return checkbox3({
                                            label: params.label,
                                            props: params.props,
                                            field: params.field,
                                            withFieldId: false
                                        });
                                    })))(function () {
                                        return displayErrorMessage1(params.field);
                                    });
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};
var checkboxField1 = /* #__PURE__ */ checkboxField(labelString)(labelString)(/* #__PURE__ */ Restaumatic_Form_FormField["isCheckboxFieldFormField$prime"](Restaumatic_Form_Checkbox.asCheckboxStateBoolean))(Restaumatic_Form_FormField["hasErrorsFormField$prime"])(Restaumatic_Form_FormField["hasLabelFormField$prime"])(Restaumatic_Form_FormField["hasFieldIdFormField$prime"])()();
var optionalWidget = function (label1) {
    return function (f) {
        return function (renderSubform) {
            return discard(checkboxField1({
                label: label1,
                field: exists(f)
            }))(function () {
                return whenD(queryLaxWithDefault(false)(exists(f)))(renderSubform(subform(f)));
            });
        };
    };
};
var alertWarning = /* #__PURE__ */ Specular_Dom_Element.el("div")([ /* #__PURE__ */ Specular_Dom_Element.class_("alert"), /* #__PURE__ */ Specular_Dom_Element.class_("alert-warning") ]);
var displayAlertWarning = function (dictHasErrors) {
    var displayedErrors = Restaumatic_Form_Internal.displayedErrors(dictHasErrors);
    return function (f) {
        return withUniqDynamic_1(displayedErrors(f))(function (errors) {
            return for_(errors)(function (error) {
                return alertWarning(Specular_Dom_Element.text(error));
            });
        });
    };
};
var alertInfo = /* #__PURE__ */ Specular_Dom_Element.el("div")([ /* #__PURE__ */ Specular_Dom_Element.class_("alert"), /* #__PURE__ */ Specular_Dom_Element.class_("alert-info") ]);
var addButton = function (dictOrd) {
    var pushItem = Restaumatic_Form_List.pushItem(dictOrd);
    return function (dictShow) {
        var pushItem1 = pushItem(dictShow)(Restaumatic_Form_List["listLikeList$prime"]);
        return function (l) {
            return Specular_Dom_Element.el("button")([ Specular_Dom_Element.classes([ "btn", "btn-default", "btn-sm" ]), Specular_Dom_Element.attr("type")("button"), Specular_Dom_Element.onClick_($$void(pushItem1(l))) ])(discard(plusIcon)(function () {
                return Specular_Dom_Element.text("Dodaj");
            }));
        };
    };
};
export {
    DefaultEmptyLabel,
    LabelDefault,
    LabelBooleanControl,
    UseDefault,
    addButton,
    alertInfo,
    alertWarning,
    checkbox,
    checkboxField,
    dateField,
    dateTimeLocalField,
    deleteButton,
    displayAlertWarning,
    displayErrorHint,
    displayErrorMessage,
    errorMessage,
    fieldset,
    fieldset$prime,
    formGroup,
    infoText,
    isDefault,
    isVisible,
    isVisibleFieldLabel,
    label,
    mappingField,
    optionalWidget,
    panel,
    panel$prime,
    panelToggle,
    panel_,
    plusIcon,
    priceField,
    radioGroup,
    renderFieldLabel,
    renderLabel,
    renderLabelWithMode,
    selectField,
    sortIcon,
    textAreaField,
    textField,
    textField$prime,
    toGroupName,
    translatedFieldWrapper,
    translatedTextAreaField,
    translatedTextField,
    wrapItem,
    labelString,
    labelUnit,
    fieldLabelDefaultEmptyLab,
    labelWidget,
    toGroupNameUseDefault,
    toGroupNameString
};
export {
    fieldId,
    fieldWrapper
} from "../Restaumatic.Form.Widgets/index.js";
